import Colors from "@constants/Colors";
import styled from "styled-components";

export const ClosedOpenCheckWrapper = styled.div`
  .amount {
    color: ${Colors.neutralblack};
  }
`;

export const LastUpdatedWrapper = styled.div`
  margin-top: 16px;
`;
